module.exports = __webpack_public_path__ + "assets/img/icon-location-address.22387ac2.png";